import { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Navbar as BsNavbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import { useDispatch } from 'react-redux';
import db from '../../db/db';
import { setAlert } from '../../actions/alert';

const Navbar = () => {
    const navigate  = useNavigate();
    const dispatch  = useDispatch();
    const [empleado,      setEmpleado]      = useState(null);
    const [eventoActivo,  setEventoActivo]  = useState(null);
    const [corteActivo,   setCorteActivo]   = useState(null);
    const [mostrarConos,  setMostrarConos]  = useState(false);
    const [cantidadConos, setCantidadConos] = useState('');
    const [statusConos,   setStatusConos]   = useState(false);
    const [conosFocused,  setConosFocused]  = useState(false);

    useEffect(() => {
        db.sesion.toArray().then(async rows => {
            if (rows.length === 0) return;
            const emp = rows[0];
            setEmpleado(emp);
            const sucursalId = emp.sucursal?._id || emp.sucursal;
            const sucReg = await db.sucursales
                .filter(s => String(s._id || s.id) === String(sucursalId))
                .first();
            setEventoActivo(sucReg?.evento || null);
        });
    }, []);

    const handleLogout = async () => {
        await db.sesion.clear();
        navigate('/');
    };

    const handleAbrirConos = async () => {
        const sucursalId = empleado?.sucursal?._id || empleado?.sucursal;
        const corte = await db.cortes
            .filter(c => c.status === false && String(c.sucursal?._id || c.sucursal) === String(sucursalId))
            .first();
        setCorteActivo(corte || null);
        setMostrarConos(true);
    };

    const handleGuardarConos = async () => {
        const cantidad = parseInt(cantidadConos) || 0;
        if (cantidad <= 0) return dispatch(setAlert('Ingresa una cantidad válida', 'danger'));
        setStatusConos(true);
        try {
            await db.conos.add({
                cantidad,
                fecha:       new Date(),
                responsable: empleado?._id || null,
                sucursal:    empleado?.sucursal?._id || empleado?.sucursal || null,
                evento:      eventoActivo?._id || null,
                corte_local_id: null,
            });
            dispatch(setAlert(`${cantidad} conos registrados`, 'success'));
            setCantidadConos('');
            setMostrarConos(false);
        } catch {
            dispatch(setAlert('Error al registrar los conos', 'danger'));
        } finally {
            setStatusConos(false);
        }
    };

    return (
        <>
            <style>{`
                .pdv-navbar {
                    background: #111111 !important;
                    border-bottom: 1px solid #2E2E2E;
                    padding: 0.6rem 0;
                }
                .pdv-navbar .navbar-toggler {
                    border-color: #2E2E2E;
                    color: #888;
                }
                .pdv-navbar .navbar-toggler-icon {
                    filter: invert(0.6);
                }
                .pdv-nav-link {
                    color: #888888 !important;
                    font-weight: 500;
                    font-size: 0.95rem;
                    padding: 0.4rem 0.85rem !important;
                    border-radius: 8px;
                    transition: color 0.2s, background 0.2s;
                }
                .pdv-nav-link:hover {
                    color: #F0F0F0 !important;
                    background: rgba(255,255,255,0.05);
                }
                .pdv-nav-link.active {
                    color: #F5C800 !important;
                    background: rgba(245,200,0,0.08);
                }
                .pdv-dropdown .dropdown-toggle {
                    color: #F0F0F0 !important;
                    font-size: 0.95rem;
                    font-weight: 500;
                    background: transparent !important;
                    border: none;
                    padding: 0.4rem 0.85rem !important;
                    border-radius: 8px;
                    transition: background 0.2s;
                }
                .pdv-dropdown .dropdown-toggle:hover,
                .pdv-dropdown .dropdown-toggle:focus,
                .pdv-dropdown.show .dropdown-toggle {
                    background: rgba(255,255,255,0.06) !important;
                    box-shadow: none !important;
                }
                .pdv-dropdown .dropdown-toggle::after {
                    border-top-color: #888;
                    margin-left: 0.5rem;
                }
                .pdv-dropdown .dropdown-menu {
                    background: #1A1A1A;
                    border: 1px solid #2E2E2E;
                    border-radius: 10px;
                    min-width: 180px;
                    padding: 0.4rem 0;
                    box-shadow: 0 8px 24px rgba(0,0,0,0.5);
                }
                .pdv-dropdown .dropdown-item {
                    color: #C0C0C0;
                    font-size: 0.9rem;
                    padding: 0.6rem 1rem;
                    transition: background 0.15s, color 0.15s;
                }
                .pdv-dropdown .dropdown-item:hover {
                    background: rgba(245,200,0,0.08);
                    color: #F5C800;
                }
                .pdv-dropdown .dropdown-divider {
                    border-color: #2E2E2E;
                    margin: 0.3rem 0;
                }
                .pdv-dropdown .dropdown-item.text-danger {
                    color: #888 !important;
                }
                .pdv-dropdown .dropdown-item.text-danger:hover {
                    color: #E53E3E !important;
                    background: rgba(229,62,62,0.08);
                }                    
                .dropdown-item.active, .dropdown-item:active {
                    background: rgba(245,200,0,0.08) !important;
                    color: #F5C800 !important;
                    text-decoration: none;
                }
                /* Mobile collapse */
                .pdv-navbar .navbar-collapse {
                    background: #111111;
                    padding: 0.5rem 0;
                }
                @media (max-width: 991px) {
                    .pdv-nav-link {
                        border-radius: 0;
                        padding: 0.65rem 1rem !important;
                    }
                    .pdv-dropdown .dropdown-toggle {
                        padding: 0.65rem 1rem !important;
                        border-radius: 0;
                        width: 100%;
                        text-align: left;
                    }
                    .pdv-dropdown .dropdown-menu {
                        background: transparent;
                        border: none;
                        box-shadow: none;
                        padding: 0;
                        margin: 0;
                    }
                    .pdv-dropdown .dropdown-item {
                        padding-left: 2rem;
                    }
                }
            `}</style>

            <BsNavbar expand="lg" className="pdv-navbar">
                <Container fluid className="px-3">
                    {/* Logo */}
                    <BsNavbar.Brand href="/dashboard">
                        <img
                            src="/assets/images/logo_blanco.png"
                            alt="Papa Roll"
                            style={{ height: '34px', width: 'auto' }}
                        />
                    </BsNavbar.Brand>

                    <BsNavbar.Toggle aria-controls="pdv-nav" />

                    <BsNavbar.Collapse id="pdv-nav">
                        {/* Links centrales */}
                        <Nav className="mx-auto">
                            <NavDropdown
                                className="pdv-dropdown"
                                title="Ventas"
                            >
                                <NavDropdown.Item as={NavLink} to="/venta">
                                    Nueva
                                </NavDropdown.Item>
                                <NavDropdown.Item as={NavLink} to="/ventas">
                                    Historial
                                </NavDropdown.Item>
                            </NavDropdown>
                            <NavDropdown
                                className="pdv-dropdown"
                                title="Ventas ambulantes"
                            >
                                <NavDropdown.Item as={NavLink} to="/vuelta">
                                    Nueva
                                </NavDropdown.Item>
                                <NavDropdown.Item as={NavLink} to="/vueltas">
                                    Historial
                                </NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item as={NavLink} to="/liquidar-vueltas">
                                    Liquidar
                                </NavDropdown.Item>
                            </NavDropdown>
                            <NavDropdown
                                className="pdv-dropdown"
                                title="Gastos"
                            >
                                <NavDropdown.Item as={NavLink} to="/gasto">
                                    Nuevo
                                </NavDropdown.Item>
                                <NavDropdown.Item as={NavLink} to="/gastos">
                                    Historial
                                </NavDropdown.Item>
                            </NavDropdown>
                            <NavDropdown
                                className="pdv-dropdown"
                                title="Cortes"
                            >
                                <NavDropdown.Item as={NavLink} to="/corte">
                                    Corte de caja
                                </NavDropdown.Item>
                                <NavDropdown.Item as={NavLink} to="/cortes">
                                    Historial
                                </NavDropdown.Item>
                            </NavDropdown>
                            <NavLink
                                to="/asistencias"
                                className={({ isActive }) => 'nav-link pdv-nav-link' + (isActive ? ' active' : '')}
                            >
                                Asistencias
                            </NavLink>
                            <button
                                className="nav-link pdv-nav-link"
                                style={{ background: 'transparent', border: 'none', cursor: 'pointer' }}
                                onClick={handleAbrirConos}
                            >
                                Conos
                            </button>
                            <NavLink
                                to="/revision"
                                className={({ isActive }) => 'nav-link pdv-nav-link' + (isActive ? ' active' : '')}
                            >
                                Revisión
                            </NavLink>
                        </Nav>

                        {/* Dropdown usuario */}
                        {empleado && (
                            <Nav className="ms-auto">
                                <NavDropdown
                                    className="pdv-dropdown"
                                    title={
                                        <>
                                            <i className="fas fa-user-circle me-2" style={{ color: '#F5C800' }}></i>
                                            {empleado.nombre || empleado.usuario}
                                        </>
                                    }
                                    align="end"
                                >
                                    <NavDropdown.Item as={NavLink} to="/configuracion">
                                        <i className="fas fa-cog me-2" style={{ color: '#555' }}></i>
                                        Configuración
                                    </NavDropdown.Item>
                                    <NavDropdown.Divider />
                                    <NavDropdown.Item className="text-danger" onClick={handleLogout}>
                                        <i className="fas fa-sign-out-alt me-2"></i>
                                        Cerrar sesión
                                    </NavDropdown.Item>
                                </NavDropdown>
                            </Nav>
                        )}
                    </BsNavbar.Collapse>
                </Container>
            </BsNavbar>

            {/* ── Modal ingreso de conos ── */}
            {mostrarConos && (
                <div
                    style={modalStyles.overlay}
                    onClick={() => { if (!statusConos) { setMostrarConos(false); setCantidadConos(''); } }}
                >
                    <div style={modalStyles.card} onClick={e => e.stopPropagation()}>
                        <div style={modalStyles.header}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
                                <i className="fas fa-ice-cream" style={{ color: '#F5C800', fontSize: '1.1rem' }}></i>
                                <span style={modalStyles.titulo}>Ingreso de conos</span>
                            </div>
                            <button
                                style={modalStyles.btnX}
                                onClick={() => { setMostrarConos(false); setCantidadConos(''); }}
                                disabled={statusConos}
                            >
                                <i className="fas fa-times"></i>
                            </button>
                        </div>
                        <div style={modalStyles.body}>
                            {!corteActivo ? (
                                <div style={modalStyles.sinCorte}>
                                    <i className="fas fa-lock" style={{ fontSize: '1.5rem', color: '#555', marginBottom: '0.5rem' }}></i>
                                    <p style={{ color: '#888', margin: 0, fontSize: '0.9rem', textAlign: 'center' }}>
                                        No hay un corte de caja activo.<br />
                                        Inicia un corte para registrar ingresos de conos.
                                    </p>
                                </div>
                            ) : (
                                <>
                                    <label style={modalStyles.label}>Cantidad de conos a ingresar</label>
                                    <CurrencyInput
                                        value={cantidadConos}
                                        onValueChange={val => setCantidadConos(val || '')}
                                        decimalsLimit={0}
                                        groupSeparator=","
                                        decimalSeparator="."
                                        placeholder="0"
                                        autoFocus
                                        onFocus={() => setConosFocused(true)}
                                        onBlur={() => setConosFocused(false)}
                                        style={{
                                            background: '#1F1F1F',
                                            border: `2px solid ${conosFocused ? '#F5C800' : '#2E2E2E'}`,
                                            boxShadow: conosFocused ? '0 0 0 2px rgba(245,200,0,0.15)' : 'none',
                                            borderRadius: '10px',
                                            padding: '0.85rem 1rem',
                                            color: '#F0F0F0',
                                            fontSize: '1.6rem',
                                            fontWeight: 800,
                                            width: '100%',
                                            outline: 'none',
                                            textAlign: 'center',
                                            fontFamily: 'inherit',
                                        }}
                                    />
                                    <button
                                        style={statusConos
                                            ? { ...modalStyles.btnGuardar, opacity: 0.6, cursor: 'not-allowed' }
                                            : modalStyles.btnGuardar
                                        }
                                        onClick={handleGuardarConos}
                                        disabled={statusConos}
                                    >
                                        {statusConos
                                            ? <><span className="spinner-border spinner-border-sm me-2" role="status" />Guardando...</>
                                            : <><i className="fas fa-check me-2"></i>Registrar</>
                                        }
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

const modalStyles = {
    overlay: {
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.75)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        padding: '1rem',
    },
    card: {
        background: '#1A1A1A',
        border: '1px solid #2E2E2E',
        borderRadius: '16px',
        width: '100%',
        maxWidth: '360px',
        overflow: 'hidden',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '1rem 1.25rem',
        borderBottom: '1px solid #2E2E2E',
        background: '#111',
    },
    titulo: {
        color: '#F0F0F0',
        fontWeight: 700,
        fontSize: '1rem',
    },
    btnX: {
        background: 'transparent',
        border: 'none',
        color: '#555',
        fontSize: '1rem',
        cursor: 'pointer',
        padding: '0.25rem 0.4rem',
    },
    body: {
        padding: '1.5rem 1.25rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
    },
    sinCorte: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '0.5rem',
        padding: '1rem 0',
    },
    label: {
        color: '#888',
        fontSize: '0.82rem',
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
    },
    btnGuardar: {
        background: '#F5C800',
        color: '#111',
        border: 'none',
        borderRadius: '10px',
        padding: '0.85rem',
        fontWeight: 800,
        fontSize: '1rem',
        cursor: 'pointer',
        width: '100%',
    },
};

export default Navbar;
